var map = {
	"./404.webp": "./src/assets/images/404.webp",
	"./alert.webp": "./src/assets/images/alert.webp",
	"./banker-tooltip.webp": "./src/assets/images/banker-tooltip.webp",
	"./bet-btn-tx.webp": "./src/assets/images/bet-btn-tx.webp",
	"./bg_major_ticket.webp": "./src/assets/images/bg_major_ticket.webp",
	"./bg_mini_ticket.webp": "./src/assets/images/bg_mini_ticket.webp",
	"./bg_minor_ticket.webp": "./src/assets/images/bg_minor_ticket.webp",
	"./blue.webp": "./src/assets/images/blue.webp",
	"./calendar.webp": "./src/assets/images/calendar.webp",
	"./close.webp": "./src/assets/images/close.webp",
	"./coin.webp": "./src/assets/images/coin.webp",
	"./dice-menu-active.webp": "./src/assets/images/dice-menu-active.webp",
	"./dice-menu.webp": "./src/assets/images/dice-menu.webp",
	"./draw-basewsoccerball.webp": "./src/assets/images/draw-basewsoccerball.webp",
	"./ended.webp": "./src/assets/images/ended.webp",
	"./flags/asean.webp": "./src/assets/images/flags/asean.webp",
	"./flags/co.webp": "./src/assets/images/flags/co.webp",
	"./flags/dr.webp": "./src/assets/images/flags/dr.webp",
	"./flags/id.webp": "./src/assets/images/flags/id.webp",
	"./flags/kh.webp": "./src/assets/images/flags/kh.webp",
	"./flags/mx.webp": "./src/assets/images/flags/mx.webp",
	"./flags/pe.webp": "./src/assets/images/flags/pe.webp",
	"./flags/ph.webp": "./src/assets/images/flags/ph.webp",
	"./flags/th.webp": "./src/assets/images/flags/th.webp",
	"./flags/vn.webp": "./src/assets/images/flags/vn.webp",
	"./flags/zh.webp": "./src/assets/images/flags/zh.webp",
	"./game-help/10min.webp": "./src/assets/images/game-help/10min.webp",
	"./game-help/betsection.webp": "./src/assets/images/game-help/betsection.webp",
	"./game-help/cambodia-bg-mobile.webp": "./src/assets/images/game-help/cambodia-bg-mobile.webp",
	"./game-help/cambodia-bg.webp": "./src/assets/images/game-help/cambodia-bg.webp",
	"./game-help/ccf-1.webp": "./src/assets/images/game-help/ccf-1.webp",
	"./game-help/ccf-2.webp": "./src/assets/images/game-help/ccf-2.webp",
	"./game-help/ccf-3.webp": "./src/assets/images/game-help/ccf-3.webp",
	"./game-help/ccf-4.webp": "./src/assets/images/game-help/ccf-4.webp",
	"./game-help/draw.webp": "./src/assets/images/game-help/draw.webp",
	"./game-help/en.webp": "./src/assets/images/game-help/en.webp",
	"./game-help/id.webp": "./src/assets/images/game-help/id.webp",
	"./game-help/jackpot/lucky-draw-instant-prize-custom.webp": "./src/assets/images/game-help/jackpot/lucky-draw-instant-prize-custom.webp",
	"./game-help/jackpot/lucky-draw-instant-prize.webp": "./src/assets/images/game-help/jackpot/lucky-draw-instant-prize.webp",
	"./game-help/jackpot/physical/major-gold.webp": "./src/assets/images/game-help/jackpot/physical/major-gold.webp",
	"./game-help/jackpot/physical/major-prize.webp": "./src/assets/images/game-help/jackpot/physical/major-prize.webp",
	"./game-help/jackpot/physical/mini-gold.webp": "./src/assets/images/game-help/jackpot/physical/mini-gold.webp",
	"./game-help/jackpot/physical/mini-prize.webp": "./src/assets/images/game-help/jackpot/physical/mini-prize.webp",
	"./game-help/jackpot/physical/minor-gold.webp": "./src/assets/images/game-help/jackpot/physical/minor-gold.webp",
	"./game-help/jackpot/physical/minor-prize.webp": "./src/assets/images/game-help/jackpot/physical/minor-prize.webp",
	"./game-help/jackpot/progress-en.webp": "./src/assets/images/game-help/jackpot/progress-en.webp",
	"./game-help/ph-bg-mobile.webp": "./src/assets/images/game-help/ph-bg-mobile.webp",
	"./game-help/ph-bg.webp": "./src/assets/images/game-help/ph-bg.webp",
	"./game-help/table-bg-mobile.webp": "./src/assets/images/game-help/table-bg-mobile.webp",
	"./game-help/table-bg.webp": "./src/assets/images/game-help/table-bg.webp",
	"./game-help/tgg-1.webp": "./src/assets/images/game-help/tgg-1.webp",
	"./game-help/tgg-2.webp": "./src/assets/images/game-help/tgg-2.webp",
	"./game-help/tgg-3.webp": "./src/assets/images/game-help/tgg-3.webp",
	"./game-help/tgg-4.webp": "./src/assets/images/game-help/tgg-4.webp",
	"./game-help/th.webp": "./src/assets/images/game-help/th.webp",
	"./game-help/vn.webp": "./src/assets/images/game-help/vn.webp",
	"./gift-box.webp": "./src/assets/images/gift-box.webp",
	"./green.webp": "./src/assets/images/green.webp",
	"./help-icon.webp": "./src/assets/images/help-icon.webp",
	"./help.webp": "./src/assets/images/help.webp",
	"./history-detail.webp": "./src/assets/images/history-detail.webp",
	"./history-icon.webp": "./src/assets/images/history-icon.webp",
	"./history.webp": "./src/assets/images/history.webp",
	"./instant-prize.webp": "./src/assets/images/instant-prize.webp",
	"./jackpot-help-icon.webp": "./src/assets/images/jackpot-help-icon.webp",
	"./jackpot-physical-btn.webp": "./src/assets/images/jackpot-physical-btn.webp",
	"./jackpot.webp": "./src/assets/images/jackpot.webp",
	"./limits.webp": "./src/assets/images/limits.webp",
	"./lobby.webp": "./src/assets/images/lobby.webp",
	"./logos/default.webp": "./src/assets/images/logos/default.webp",
	"./logos/p1.webp": "./src/assets/images/logos/p1.webp",
	"./logos/worldcup-logo.webp": "./src/assets/images/logos/worldcup-logo.webp",
	"./major-ticket-star.webp": "./src/assets/images/major-ticket-star.webp",
	"./major-ticket.webp": "./src/assets/images/major-ticket.webp",
	"./mini-ticket.webp": "./src/assets/images/mini-ticket.webp",
	"./minor-ticket.webp": "./src/assets/images/minor-ticket.webp",
	"./notification-icon.webp": "./src/assets/images/notification-icon.webp",
	"./notification.webp": "./src/assets/images/notification.webp",
	"./past-flag.webp": "./src/assets/images/past-flag.webp",
	"./player-tooltip.webp": "./src/assets/images/player-tooltip.webp",
	"./red.webp": "./src/assets/images/red.webp",
	"./schedule-white.webp": "./src/assets/images/schedule-white.webp",
	"./schedules.webp": "./src/assets/images/schedules.webp",
	"./shine-bg.webp": "./src/assets/images/shine-bg.webp",
	"./sparkle.webp": "./src/assets/images/sparkle.webp",
	"./start_game_icon.webp": "./src/assets/images/start_game_icon.webp",
	"./statement-icon.webp": "./src/assets/images/statement-icon.webp",
	"./statement.webp": "./src/assets/images/statement.webp",
	"./super-draw-past.webp": "./src/assets/images/super-draw-past.webp",
	"./super-draw.webp": "./src/assets/images/super-draw.webp",
	"./sword-fight-black.webp": "./src/assets/images/sword-fight-black.webp",
	"./sword-fight-white.webp": "./src/assets/images/sword-fight-white.webp",
	"./user.webp": "./src/assets/images/user.webp",
	"./worldcup-bg-mobile.webp": "./src/assets/images/worldcup-bg-mobile.webp",
	"./worldcup-bg.webp": "./src/assets/images/worldcup-bg.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.webp$";